import React, { useContext, useEffect, useState } from "react";
import zohoLogo from "../images/zoho_logo.png";
import LoadingIcon from "../images/Loading_icon.gif";
import Swal from "sweetalert2";
import { UrlContext } from "../contexts/UrlContext";

export default function NewinZoho() {
  const [profiles, setProfiles] = useState([]);
  const [loadingPage, setLoadingPage] = useState(false);
  const [loadingAdd, setLoadingAdd] = useState("");
  const { API_URL } = useContext(UrlContext);
  const tokenObj = localStorage.getItem("eph-token");
  const token = JSON.parse(tokenObj).value;
  const [newExperts, setNewExperts] = useState([]);
  const [showButtons, setShowButtons] = useState(false);
  const [addingMultiple, setAddingMultiple] = useState(false);

  useEffect(() => {
    setLoadingPage(true);
    fetch(`${API_URL}get-profiles-from-zoho`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setProfiles(data.experts);
        setLoadingPage(false);
      })
      .catch((err) => {
        Swal.fire({
          title: "Error",
          text: `${err.message}`,
          timer: 2000,
          icon: "error",
        });
        setLoadingPage(false);
      });
  }, []);

  function handleSelect(experts) {
    setLoadingAdd(experts.name);
    fetch(`${API_URL}add-expert-to-database`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ experts }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoadingAdd("");
        if (data.status === "success") {
          setProfiles((prevProfiles) =>
            prevProfiles.filter((profile) => profile.name !== experts.name)
          );
          Swal.fire({
            title: "Expert Added ",
            icon: "success",
            text: `${data.text}`,
            timer: 2000,
          });
        } else if (data.text === "Expert already exists in database!") {
          setProfiles((prevProfiles) =>
            prevProfiles.filter((profile) => profile.name !== experts.name)
          );
          Swal.fire({
            title: "Error",
            text: `${data.text}`,
            timer: 2000,
            icon: "error",
          });
          setLoadingAdd("");
        } else {
          Swal.fire({
            title: "Error",
            text: `${data.text}`,
            timer: 2000,
            icon: "error",
          });
        }
        setLoadingAdd("");
      })
      .catch((err) => {
        Swal.fire({
          title: "Error",
          text: `${err.message}`,
          timer: 2000,
          icon: "error",
        });
        setLoadingAdd("");
      });
  }

  const appendExperts = (experts) => {
    // console.log(experts)
    const newExpert = [...newExperts];
    newExpert.push(experts);
    setNewExperts(newExpert);
    // console.log(newExperts)
  };
  const removeExperts = (experts) => {
    // console.log(experts)
    const newExpert = newExperts.filter((ex) => ex.email !== experts.email);
    // console.log(newExpert)
    setNewExperts(newExpert);
  };

  useEffect(() => {
    if (newExperts.length > 0) {
      setShowButtons(true);
    } else {
      setShowButtons(false);
    }
  }, [newExperts]);

  const handleAddExperts = () => {
    setAddingMultiple(true);
    // fetch(`${API_URL}add-expert-to-database`, {
    fetch(`${API_URL}add-mutliple-expert-to-database`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ newExperts }),
    })
      .then((res) => res.json())
      .then((data) => {
        setAddingMultiple(false);
        if (data.status === "success") {
          console.log("data returned", data);
          setProfiles((prevProfiles) =>
            prevProfiles.filter(
              (profile) =>
                !newExperts.some((expert) => expert.name === profile.name)
            )
          );

          const strExpAdded = data.addedExperts.join(", ");
          if (data.existingExperts.length > 0) {
            var strExisExpert = data.existingExperts.join(", ");
          }
          const successMessage = `Experts Added to Database: ${strExpAdded}
          ${
            data.existingExperts.length > 0
              ? `Experts Existing in Database: ${strExisExpert}`
              : ""
          }`;
          Swal.fire({
            title: "Expert Added ",
            icon: "success",
            text: `${successMessage}`,
            timer: 2000,
          });
        } else {
          Swal.fire({
            title: "Error",
            text: `${data.text}`,
            timer: 2000,
            icon: "error",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          title: "Error",
          text: `${err.message}`,
          timer: 2000,
          icon: "error",
        });
      });
  };

  const handleRemoveExperts = () => {
    setAddingMultiple(true);
    // fetch(`${API_URL}add-expert-to-database`, {
    fetch(`${API_URL}remove-expert-from-database`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ newExperts }),
    })
      .then((res) => res.json())
      .then((data) => {
        setAddingMultiple(false);
        if (data.status === "success") {
          setProfiles((prevProfiles) =>
            prevProfiles.filter(
              (profile) =>
                !newExperts.some((expert) => expert.name === profile.name)
            )
          );
          Swal.fire({
            title: "Expert Added ",
            icon: "success",
            text: `${data.text}`,
            timer: 2000,
          });
        } else {
          Swal.fire({
            title: "Error",
            text: `${data.text}`,
            timer: 2000,
            icon: "error",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          title: "Error",
          text: `${err.message}`,
          timer: 2000,
          icon: "error",
        });
      });
  };

  return (
    <div className="container-div position-relative">
      <center>
        <div
          style={{
            textAlign: "center",
            marginTop: "20px",
            marginBlock: "20px",
          }}
        >
          <h3>Profiles New to Zoho</h3>
        </div>
      </center>
      {loadingPage ? (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <img src={LoadingIcon} alt="Loading..." style={{ height: "50px" }} />
        </div>
      ) : (
        profiles.map((expert) => (
          <>
            <div key={expert.name} className="search-con-row-top">
              <ul className="list-unstyled form-inline">
                <li className="search-con-name-section">
                  {/* <a
                  href={`/ExpertDetails/${expert.id}`}
                  className="search-con-eph-profile"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className={`search-con-img ${availabiltyBorder}`}
                    alt=""
                    src={
                      expert.profile_picture
                        ? expert.profile_picture
                        : expertDefaultImg
                    }
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = expertDefaultImg;
                    }}
                  />
                </a> */}
                  <div style={{ display: "inline-grid" }}>
                    <input
                      className="single-checkbox"
                      type="checkbox"
                      onChange={(e) => {
                        if (e.target.checked) {
                          appendExperts(expert);
                        } else {
                          removeExperts(expert);
                        }
                      }}
                    />
                    {expert.link !== "" ? (
                      <a
                        href={expert.link}
                        className="search-con-name-tag"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ marginLeft: "15px" }}
                      >
                        {expert.name}
                      </a>
                    ) : (
                      <span>{expert.name}</span>
                    )}

                    {expert.parcentage && (
                      <p style={{ fontSize: "14px" }}>
                        Score: {expert.parcentage ? expert.parcentage : null}
                      </p>
                    )}
                  </div>
                </li>
                <li className="search-con-location-section">
                  <span className="search-con-location-tag">
                    {expert.location}
                  </span>
                </li>
                {/* <li className="search-con-available-comment">
                {showComment && (
                  <AvailabilityComment
                    comment={availabilityComment}
                    expert_id={expert.id}
                    setAvailabilityComment={setAvailabilityComment}
                    backupData={backupData}
                    setBackupData={setBackupData}
                    setShowComment={setShowComment}
                  />
                )}
              </li> */}
                <li className="search-con-summary">
                  <div title="Summary" className="info-div1-scroll">
                    {expert.summary}
                  </div>
                </li>
                <li className="search-con-experience">
                  <div title="Experience" className="info-div2-scroll">
                    {expert.experience}
                  </div>
                </li>
                <button
                  className="btn select-profile-btn"
                  onClick={() => handleSelect(expert)}
                >
                  {loadingAdd == expert.name ? (
                    <img
                      src={LoadingIcon}
                      alt="Loading..."
                      style={{ height: "20px" }}
                    />
                  ) : (
                    <i className="fa-solid fa-user-plus" />
                  )}{" "}
                  Add
                </button>
              </ul>
            </div>
            <div className="search-con-row-bottom">
              <ul
                className="list-unstyled form-inline"
                style={{ marginBottom: 0 }}
              >
                <li className="search-con-email-section">
                  <div className="search-con-email">
                    <i className="fa-regular fa-envelope" />
                    <span>{expert.email}</span>
                    {/* <EditProfileBasic
                    expert_id={expert?.id}
                    expert_Name={expert?.name}
                    expert_link={expert?.link}
                    expert_email={expert?.email}
                    updateProfileData={updateProfileData}
                  /> */}
                  </div>
                </li>
                <li className="search-con-available-date">
                  <i className="calender-icon fa-regular fa-calendar-days" />
                  <label>Availability</label>
                  {/* <i
                  className={
                    availabilityComment
                      ? "comment-icon fa-regular fa-comment-dots"
                      : "comment-icon comment-empty fa-regular fa-comment-dots"
                  }
                  title="Click to see comment"
                  onClick={() => setShowComment(!showComment)}
                /> */}
                  {/* <AvailabilityDate
                  date={expert.available_from}
                  expertID={expert.id}
                  setAvailablityDate={setAvailablityDate}
                  backupData={backupData}
                  setBackupData={setBackupData}
                /> */}
                </li>
                <li className="search-con-empty-class"></li>
                <li className="search-con-exLogo-section">
                  {expert.logo1 ? <img src={expert.logo1} alt="" /> : null}
                  {expert.logo2 ? <img src={expert.logo2} alt="" /> : null}
                  {expert.logo3 ? <img src={expert.logo3} alt="" /> : null}
                  {expert.logo4 ? <img src={expert.logo4} alt="" /> : null}
                  {expert.logo5 ? <img src={expert.logo5} alt="" /> : null}
                </li>
              </ul>
              {expert.in_zoho === "yes" && (
                <div className="search-con-inZoho">
                  <img src={zohoLogo} alt="in_zoho" title="In Zoho" />
                </div>
              )}
            </div>
          </>
        ))
      )}
      <center>
        <div style={{ padding: "20px" }}>
          {showButtons && (
            <>
              <button
                className="btn select-profile-btn"
                style={{ width: "150px" }}
                onClick={handleAddExperts}
              >
                <i className="fa fa-plus-square" /> Add Experts
              </button>
              <button
                className="btn select-profile-btn"
                style={{ width: "200px" }}
                onClick={handleRemoveExperts}
              >
                <i className="fa fa-trash-o" /> Remove Experts
              </button>
            </>
          )}
        </div>
      </center>
      {addingMultiple && (
        <div className="updateToZoho-popup-wrapper">
          <div className="tab-pane fade show updateToZoho-div">
            <center>
              <p style={{ fontSize: "18px" }}>Adding Multiple Experts...</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </div>
  );
}
